import { FormControl, FormDescription, FormItem, FormMessage, useFormField } from "@ui/shad"
import { ControllerRenderProps, FieldValues, Path } from "react-hook-form"

import { ComboboxInput } from "../inputs/combobox-input"

interface ComboboxFieldProps<T extends FieldValues>
  extends Omit<React.ComponentProps<typeof ComboboxInput>, "value" | "onChange" | "error"> {
  id: string
  description?: string
  field: ControllerRenderProps<T, Path<T>>
}

export function ComboboxField<T extends FieldValues>({ field, id, description, ...props }: ComboboxFieldProps<T>) {
  const { error } = useFormField()

  return (
    <FormItem>
      <FormControl>
        <ComboboxInput
          id={id}
          value={field.value}
          onChange={field.onChange}
          onSearch={props.onSearch}
          error={!!error}
          {...props}
        />
      </FormControl>
      {description && <FormDescription>{description}</FormDescription>}
      <FormMessage />
    </FormItem>
  )
}

/* Example Usage:
interface FormData {
  framework: string;
}

<FormField
  control={form.control}
  name="framework"
  render={({ field }) => (
    <ComboboxField<FormData>
      field={field}
      id="framework"
      label="Framework"
      description="Select your preferred framework"
      placeholder="Select framework"
      options={[
        { value: "next", label: "Next.js" },
        { value: "react", label: "React" },
        { value: "vue", label: "Vue" },
      ]}
    />
  )}
/>
*/
